import { BatchSelectionRow } from "../types";

export function isRowEmpty(row?: BatchSelectionRow): boolean {
  if (!row) return true;
  return (
    row.additionalReference === "" &&
    row.differentialTemperature === "" &&
    row.pipeSize === "" &&
    row.dp === "" &&
    row.flow === "" &&
    row.power === "" &&
    row.quantity === "" &&
    row.reference === ""
  );
}
